import styled from 'styled-components';

export const CoursesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    grid-template-columns: 1fr 1fr;
  }
`;
